import React from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { TableWrapper } from "App/Component/ui";

import { useDatatables } from "App/hooks";

export default function DaftarTidakDitemukan({ rows }) {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "barang_id",
    orderByRow: ["barang_id", "namaBarang", "qty"],
  });

  return (
    <>
      <TableWrapper
        title='Tidak Ditemukan di Excel'
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>
                <TableCell align='left'>{row?.barang_id}</TableCell>
                <TableCell align='left'>{row?.namaBarang}</TableCell>
                <TableCell align='left'>{row?.qty}</TableCell>
              </TableRow>
            );
          })}
      </TableWrapper>
    </>
  );
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "barang_id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "namaBarang",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "QTY",
    align: "left",
  },
];
